// import cornerstoneTools from 'cornerstone-tools';
const BaseAnnotationTool = cornerstoneTools.importInternal('base/BaseAnnotationTool');
const external = cornerstoneTools.external;

const EVENTS = cornerstoneTools.EVENTS
const toolStyle = cornerstoneTools.toolStyle;
const textStyle = cornerstoneTools.textStyle;
const toolColors = cornerstoneTools.toolColors;
const moveNewHandle = cornerstoneTools.importInternal('manipulators/moveNewHandle');
const moveHandle = cornerstoneTools.importInternal('manipulators/moveHandle');
const pointInsideBoundingBox = cornerstoneTools.importInternal('util/pointInsideBoundingBox');
const lineSegDistance = cornerstoneTools.importInternal('util/lineSegDistance');
const triggerEvent = cornerstoneTools.importInternal('util/triggerEvent');

const addToolState = cornerstoneTools.addToolState;
const removeToolState = cornerstoneTools.removeToolState;
const getToolState = cornerstoneTools.getToolState;
// import {
//   addToolState,
//   removeToolState,
//   getToolState,
// } from './../../stateManagement/toolState.js';
const drawLinkedTextBox = cornerstoneTools.importInternal('drawing/drawLinkedTextBox');
const drawTextBox = cornerstoneTools.importInternal('drawing/drawTextBox');
// import drawLinkedTextBox from './../../drawing/drawLinkedTextBox.js';
const getNewContext = cornerstoneTools.importInternal('drawing/getNewContext');
const draw = cornerstoneTools.importInternal('drawing/draw');
const setShadow = cornerstoneTools.importInternal('drawing/setShadow');
// import { getNewContext, draw, setShadow } from './../../drawing/index.js';
const drawArrow = cornerstoneTools.importInternal('drawing/drawArrow');
// import drawArrow from './../../drawing/drawArrow.js';
const drawHandles = cornerstoneTools.importInternal('drawing/drawHandles');
// import drawHandles from './../../drawing/drawHandles.js';

const textBoxWidth = cornerstoneTools.importInternal('drawing/drawTextBox');
// import { textBoxWidth } from './../../drawing/drawTextBox.js';
const cursors = cornerstoneTools.import('tools/cursors');
// import { arrowAnnotateCursor } from '../cursors/index.js';
// import { getModule } from '../../store/index';

/**
 * @public
 * @class ArrowAnnotateTool
 * @memberof Tools.Annotation
 * @classdesc Create and position an arrow and label
 * @extends Tools.Base.BaseAnnotationTool
 */
export default class TextAnnotationTool extends BaseAnnotationTool {
  constructor(props = {}) {
    const defaultProps = {
      name: 'TextAnnotate',
      supportedInteractionTypes: ['Mouse', 'Touch'],
      configuration: {
        changeTextCallback,
      },
      svgCursor: cursors.textMarkerCursor,
    };

    super(props, defaultProps);
    this.touchPressCallback = this._changeText.bind(this);
    this.doubleClickCallback = this._changeText.bind(this);

  }

  createNewMeasurement(eventData) {

    // Create the measurement data for this tool with the end handle activated
    const measurementData = {
      visible: true,
      active: true,
      text: '',
      color: undefined,
      handles: {
        end: {
          x: eventData.currentPoints.image.x,
          y: eventData.currentPoints.image.y,
          highlight: true,
          active: true,
          hasBoundingBox: true,
        },
      },
    };

    // Create a rectangle representing the image
    const imageRect = {
      left: 0,
      top: 0,
      width: eventData.image.width,
      height: eventData.image.height,
    };

    // Check if the current handle is outside the image,
    // If it is, prevent the handle creation
    if (
      !external.cornerstoneMath.point.insideRect(
        measurementData.handles.end,
        imageRect
      )
    ) {
      alert('No se pueden poner anotaciones fuera de la imagen');
      return;
    }

    measurementData.text = '';
    // let text = prompt('Introduce el texto:');
    // measurementData.text = text

    return measurementData;
  }

  pointNearTool(element, data, coords) {
    if (data.visible === false) {
      return false;
    }

    if (!data.handles.end.boundingBox) {
      return;
    }

    const distanceToPoint = external.cornerstoneMath.rect.distanceToPoint(
      data.handles.end.boundingBox,
      coords
    );
    const insideBoundingBox = pointInsideBoundingBox(data.handles.end, coords);

    return distanceToPoint < 10 || insideBoundingBox;
  }

  updateCachedStats() {
    // Implementing to satisfy BaseAnnotationTool
  }

  renderToolData(evt) {
    const eventData = evt.detail;
    const config = this.configuration;

    // If we have no toolData for this element, return immediately as there is nothing to do
    const toolData = getToolState(eventData.element, this.name);

    if (!toolData) {
      return;
    }

    // We have tool data for this element - iterate over each one and draw it
    const context = getNewContext(eventData.canvasContext.canvas);

    for (let i = 0; i < toolData.data.length; i++) {
      const data = toolData.data[i];

      if (data.visible === false) {
        continue;
      }

      const color = toolColors.getColorIfActive(data);

      draw(context, context => {
        setShadow(context, config);

        const textCoords = external.cornerstone.pixelToCanvas(
          eventData.element,
          data.handles.end
        );

        const options = {
          centering: {
            x: true,
            y: true,
          },
        };

        data.handles.end.boundingBox = drawTextBox(
          context,
          data.text,
          textCoords.x,
          textCoords.y - 10,
          color,
          options
        );
      });
    }
  }

  _changeText(evt) {
    const eventData = evt.detail;
    const { element, currentPoints } = eventData;
    let data;

    function doneChangingTextCallback(data, updatedText, deleteTool) {
      if (deleteTool === true) {
        removeToolState(element, this.name, data);
      } else {
        data.text = updatedText;
      }

      data.active = false;
      external.cornerstone.updateImage(element);
    }

    const config = this.configuration;
    const coords = currentPoints.canvas;
    const toolData = getToolState(element, this.name);

    // Now check to see if there is a handle we can move
    if (!toolData) {
      return;
    }

    for (let i = 0; i < toolData.data.length; i++) {
      data = toolData.data[i];
      if (this.pointNearTool(element, data, coords) || !data.handles.end.boundingBox) {
        data.active = true;
        external.cornerstone.updateImage(element);

        // Allow relabelling via a callback
        config.changeTextCallback(data, eventData, doneChangingTextCallback);

        evt.stopImmediatePropagation();
        evt.preventDefault();
        evt.stopPropagation();

        return;
      }
    }
  }

  addNewMeasurement(evt) {
    console.log('Enter new measurement', evt);
    const element = evt.detail.element;
    const measurementData = this.createNewMeasurement(evt.detail);

    addToolState(element, this.name, measurementData);
    triggerEvent(
      element,
      EVENTS.MEASUREMENT_COMPLETED,
      measurementData
    );
    this._changeText(evt);

    external.cornerstone.updateImage(element);
  }

}

/**
 * This function is a callback to be overwriten in order to provide the wanted feature
 * modal, overlay, popup or any kind of interaction with the user to be able to update
 * the text marker label.
 *
 * @param  {Object} data
 * @param  {Object} eventData
 * @param  {doneChangingTextCallback} doneChangingTextCallback
 * @returns {void}
 */
function changeTextCallback(data, eventData, doneChangingTextCallback) {
  document.getElementById('ArrowAnnotatePopupInput').value = data.text;
  document.getElementById('ArrowAnnotatePopup').style.display = 'block';
  document.getElementById('ArrowAnnotatePopupInput').focus();
  document.getElementById('ArrowAnnotatePopupButtonConfirm').addEventListener('click', () => {
    const txt = document.getElementById('ArrowAnnotatePopupInput').value;
    doneChangingTextCallback(data, txt);
    document.getElementById('ArrowAnnotatePopup').style.display = 'none';
  }, { once: true })
}

/**
 * @callback doneChangingTextCallback
 * @param {Object} data
 * @param {string} text - The new text
 */
